import type { AnalysisFormat } from '@/formats/analysis-formats';
import AnalysisParser from '@/formats/AnalysisParser';
import type { Analysis, Piece } from '@/data';
import type { Response } from './ClientResponse';
import { ClientResponse } from './ClientResponse';

import type { IClient } from './IClient';

export async function loadAnalysis(
  this: IClient,
  piece: Piece,
  analysisId: string,
): Promise<Response<Analysis>> {
  const url = this.url(piece.path, 'analyses', analysisId);

  if (!url.isOk()) return url.cast();

  const response = await this.get<AnalysisFormat>(url.data);

  if (response.isErr()) return response.cast();

  response.data.signature = piece.signature;

  return this.tryParse(() => AnalysisParser.parseFormat(response.data, analysisId));
}

export async function loadAnalysesList(this: IClient, id: string): Promise<Response<string[]>> {
  const url = this.url(id, 'analyses');

  if (!url.isOk()) return url.cast();

  return this.getFolder(`${this.analysesUrl}corpus/${id.replace(/\//g, ('%2F'))}/analyses`);
}

export async function uploadAnalysis(
  this: IClient,
  piecePath: string,
  analysisId: string,
  analysis: Analysis,
): Promise<Response<unknown>> {
  let body;
  try {
    const format = AnalysisParser.exportFormat(analysis);
    const content = JSON.stringify(format);
    body = { name: analysisId, content };
  } catch (e) {
    return ClientResponse.fromParsingError(e as Error);
  }
  const url = this.url(piecePath, 'analyses');

  if (!url.isOk()) return url.cast();

  return this.post<unknown>(url.data, body);
}
